export const addBase64Prefix = (data: string) =>
  `data:image/jpeg;base64,${data}`;
